import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyCl1ejvMaKhHFrR8og8mzljYPTCbnSDlCI",
    authDomain: "ravitodoapp.firebaseapp.com",
    databaseURL: "https://ravitodoapp.firebaseio.com",
    projectId: "ravitodoapp",
    storageBucket: "ravitodoapp.appspot.com",
    messagingSenderId: "901284214358",
    appId: "1:901284214358:web:6136d764d399c0ac93adf7",
    measurementId: "G-S35ZZM2KDE"
  });

const db = firebaseApp.firestore();

export default db;
